var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.blockParams.templateCode && (_vm.block?.siteId?.length ? _vm.block?.siteId?.includes(_vm.$authNew?.siteId) : true))?_c(_vm.blockParams.templateCode,_vm._b({tag:"component",attrs:{"block-id":_vm.block?.id,"fields":_vm.blockFields,"title":_vm.blockTitle,"block-params":_vm.blockParams,"page-title":_vm.pageTitle},on:{"sites:change":function($event){return _vm.$authNew.setToken({ typeOfToken: 'siteId', newToken: $event })},"block:redirect":_vm.redirect},scopedSlots:_vm._u([{key:"children",fn:function(){return [(_vm.currentSiteBlocks.length)?_c('div',{class:{
        'pos-hor': _vm.block.params.isHorizontal
      },style:({
        'padding-top': _vm.block.params.isHorizontal
          ? `${_vm.block.params.paddingTop}px`
          : undefined,
        'padding-bottom': _vm.block.params.isHorizontal
          ? `${_vm.block.params.paddingBottom}px`
          : undefined,
      })},[_vm._l((_vm.currentSiteBlocks),function(item,idx){return [_c('recursive-component',{key:item.id,style:(_vm.calculatedFlex(idx)),attrs:{"block":item,"page-title":_vm.pageTitle}}),_vm._v(" "),(
            _vm.blockParams.isHorizontal &&
              !(
                (idx + 1) %
                (_vm.blockParams.blockPerRow ? _vm.blockParams.blockPerRow : 1)
              )
          )?_c('div',{key:`break${idx}`,staticClass:"break"}):_vm._e()]})],2):_vm._e()]},proxy:true}],null,false,2009821298)},'component',_vm.blockParams,false),[_vm._v("\n  "+_vm._s(_vm.block)+"\n  ")]):(_vm.currentSiteBlocks.length && (_vm.block?.siteId?.length ? _vm.block?.siteId?.includes(_vm.$authNew?.siteId) : true))?_c('div',{class:{
    container: _vm.block.params.useContainer,
    'pos-hor': _vm.block.params.isHorizontal,
    'redirect-block-select': _vm.blockParams?.isUrl
  },style:({
    'padding-top': _vm.block.params.isHorizontal
      ? `${_vm.block.params.paddingTop}px`
      : undefined,
    'padding-bottom': _vm.block.params.isHorizontal
      ? `${_vm.block.params.paddingBottom}px`
      : undefined,
  }),on:{"click":_vm.redirect}},[_vm._l((_vm.currentSiteBlocks),function(item,idx){return [_c('recursive-component',{key:item.id,style:(_vm.calculatedFlex(idx)),attrs:{"block":item,"page-title":_vm.pageTitle}}),_vm._v(" "),(
        _vm.blockParams.isHorizontal &&
          !((idx + 1) % (_vm.blockParams.blockPerRow ? _vm.blockParams.blockPerRow : 1))
      )?_c('div',{key:`break${idx}`,staticClass:"break"}):_vm._e()]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }